import React from "react";
import AddFriendsController, { Props } from "./AddFriendsController";
import NavigationMenu from "../../navigationmenu/src/NavigationMenu.web";
import { Box } from "@mui/material";
import CommonHeader from "../../utilities/src/CommonHeader.web";
import Button from '@mui/material/Button';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { pitch, noPitch, favourites, notFavourites, offlineIndicator, onlineIndicator, chat, share, block } from "./assets";

interface Contact {
  id: string;
  name: string;
  role: string;
  company: string;
  location: string;
  avatar: string;
  isOnline: boolean;
  isFavorite: boolean;
  backgroundColor: string;
  pitch: boolean;
}

export const defaultContacts: Contact[] = [
  {
    id: "1",
    name: "Aarav Sharma",
    role: "Software Engineer",
    company: "Apple",
    location: "Bangalore",
    avatar: "https://dashboard.codeparrot.ai/api/image/aB2KkZV6LyR_hpXQ/image-pe.png",
    isOnline: true,
    isFavorite: true,
    backgroundColor: "#d2bdff",
    pitch: true
  },
  {
    id: "2",
    name: "Sophia Martinez",
    role: "Software Engineer",
    company: "Google",
    location: "Bangalore",
    avatar: "https://dashboard.codeparrot.ai/api/image/aB2KkZV6LyR_hpXQ/image-pe-2.png",
    isOnline: true,
    isFavorite: true,
    backgroundColor: "#e2cbf7",
    pitch: false
  },
  {
    id: "3",
    name: "Nabeel Ali",
    role: "React Developer",
    company: "Magic",
    location: "Noida",
    avatar: "https://dashboard.codeparrot.ai/api/image/aB2KkZV6LyR_hpXQ/image-pe-4.png",
    isOnline: false,
    isFavorite: false,
    backgroundColor: "#ffecd6",
    pitch: true
  },
  {
    backgroundColor: "#ffecd6",
    pitch: false,
    id: "4",
    name: "James Anderson",
    role: "Product Manager",
    company: "Amazon",
    location: "Mumbai",
    avatar: "https://dashboard.codeparrot.ai/api/image/aB2KkZV6LyR_hpXQ/image-pe-4.png",
    isOnline: false,
    isFavorite: false,
  },
  {
    id: "5",
    name: "Emma Wilson",
    location: "Delhi",
    avatar: "https://dashboard.codeparrot.ai/api/image/aB2KkZV6LyR_hpXQ/image-pe-5.png",
    isOnline: true,
    isFavorite: true,
    backgroundColor: "#ffcccb",
    pitch: true,
    role: "UX Designer",
    company: "Netflix",
  },
  {
    id: "6",
    isFavorite: false,
    name: "Michael Chen",
    location: "Chennai",
    avatar: "https://dashboard.codeparrot.ai/api/image/aB2KkZV6LyR_hpXQ/image-pe-6.png",
    role: "Data Scientist",
    company: "Tesla",
    isOnline: false,
    backgroundColor: "#b5d5cc",
    pitch: false
  },
  {
    id: "7",
    name: "Isabella Garcia",
    role: "DevOps Engineer",
    company: "Uber",
    location: "Pune",
    avatar: "https://dashboard.codeparrot.ai/api/image/aB2KkZV6LyR_hpXQ/image-pe-7.png",
    isOnline: true,
    isFavorite: true,
    backgroundColor: "#d2b4de",
    pitch: true
  },
  {
    avatar: "https://dashboard.codeparrot.ai/api/image/aB2KkZV6LyR_hpXQ/image-pe-8.png",
    id: "8",
    name: "David Kim",
    isFavorite: false,
    backgroundColor: "#ffb347",
    role: "Cloud Architect",
    company: "IBM",
    location: "Hyderabad",
    isOnline: false,
    pitch: false
  },
  {
    id: "9",
    name: "Olivia Martinez",
    role: "AI Researcher",
    company: "NVIDIA",
    isFavorite: true,
    avatar: "https://dashboard.codeparrot.ai/api/image/aB2KkZV6LyR_hpXQ/image-pe-9.png",
    isOnline: true,
    backgroundColor: "#c2d9d9",
    location: "Kolkata",
    pitch: true
  },
  {
    name: "Ethan Wright",
    id: "10",
    avatar: "https://dashboard.codeparrot.ai/api/image/aB2KkZV6LyR_hpXQ/image-pe-10.png",
    role: "Blockchain Developer",
    company: "Ripple",
    location: "Ahmedabad",
    isOnline: false,
    isFavorite: false,
    backgroundColor: "#e8d0b0",
    pitch: false
  },
  {
    id: "11",
    name: "Mia Taylor",
    role: "Cybersecurity Analyst",
    company: "Cisco",
    location: "Surat",
    isOnline: true,
    isFavorite: true,
    backgroundColor: "#f0e6ff",
    avatar: "https://dashboard.codeparrot.ai/api/image/aB2KkZV6LyR_hpXQ/image-pe-11.png",
    pitch: true
  },
  {
    name: "Liam Patel",
    role: "Mobile Developer",
    company: "Snapchat",
    location: "Jaipur",
    avatar: "https://dashboard.codeparrot.ai/api/image/aB2KkZV6LyR_hpXQ/image-pe-12.png",
    isOnline: false,
    isFavorite: false,
    backgroundColor: "#d8e4bc",
    pitch: false,
    id: "12",
  },
  {
    id: "13",
    name: "Olivia Rivera",
    backgroundColor: "#ffeadb",
    company: "Twitter",
    location: "Lucknow",
    avatar: "https://dashboard.codeparrot.ai/api/image/aB2KkZV6LyR_hpXQ/image-pe-13.png",
    isOnline: true,
    isFavorite: true,
    role: "Full Stack Developer",
    pitch: true
  },
  {
    id: "14",
    name: "Noah Lee",
    role: "Frontend Developer",
    company: "Github",
    location: "Vadodara",
    pitch: false,
    avatar: "https://dashboard.codeparrot.ai/api/image/aB2KkZV6LyR_hpXQ/image-pe-14.png",
    isOnline: false,
    isFavorite: false,
    backgroundColor: "#a2c8ec",
  },
  {
    id: "15",
    name: "Charlotte Scott",
    role: "Backend Developer",
    company: "Slack",
    location: "Bhopal",
    isOnline: true,
    isFavorite: true,
    backgroundColor: "#ffccbc",
    pitch: true,
    avatar: "https://dashboard.codeparrot.ai/api/image/aB2KkZV6LyR_hpXQ/image-pe-15.png",
  },
  {
    id: "16",
    name: "Mason Lewis",
    role: "UI/UX Designer",
    company: "Dribbble",
    isOnline: false,
    isFavorite: false,
    location: "Nagpur",
    avatar: "https://dashboard.codeparrot.ai/api/image/aB2KkZV6LyR_hpXQ/image-pe-16.png",
    backgroundColor: "#e8f5e9",
    pitch: false
  },
  {
    id: "17",
    backgroundColor: "#fce4ec",
    name: "Ava Wilson",
    role: "QA Engineer",
    company: "Selenium",
    location: "Patna",
    avatar: "https://dashboard.codeparrot.ai/api/image/aB2KkZV6LyR_hpXQ/image-pe-17.png",
    isOnline: true,
    isFavorite: true,
    pitch: true
  },
  {
    id: "18",
    name: "Logan Howard",
    role: "Technical Writer",
    company: "Medium",
    location: "Rajkot",
    isFavorite: false,
    avatar: "https://dashboard.codeparrot.ai/api/image/aB2KkZV6LyR_hpXQ/image-pe-18.png",
    isOnline: false,
    backgroundColor: "#fff9c4",
    pitch: false
  },
  {
    name: "Amelia Cooper",
    role: "DevOps Engineer",
    company: "Docker",
    location: "HongKong",
    avatar: "https://dashboard.codeparrot.ai/api/image/aB2KkZV6LyR_hpXQ/image-pe-19.png",
    id: "19",
    isOnline: true,
    isFavorite: true,
    backgroundColor: "#c8e6c9",
    pitch: true
  },
  {
    id: "20",
    name: "Lucas Evans",
    backgroundColor: "#d7e8f7",
    pitch: false,
    role: "Data Engineer",
    company: "Snowflake",
    location: "Guwahati",
    avatar: "https://dashboard.codeparrot.ai/api/image/aB2KkZV6LyR_hpXQ/image-pe-20.png",
    isOnline: false,
    isFavorite: false,
  }
];

export default class AddFriends extends AddFriendsController {
  constructor(props: Props) {
    super(props);
    // Customizable Area Start
    // Customizable Area End
  }

  // Customizable Area Start
  renderAlphabetItem = (letter: string, index: number) => {
    return (
      <Typography
        data-test-id={`alphabet-item-${letter}`}
        onClick={() => this.handleAlphabetClick(letter)}
        key={letter}
        style={{
          width: '11px',
          height: '18px',
          color: '#ffffff',
          fontSize: '15px',
          fontFamily: 'Inter',
          fontWeight: 500,
          lineHeight: '18px',
          textAlign: 'center',
          textTransform: 'uppercase',
          cursor: 'pointer',
          marginBottom: '3px',
        }}
      >
        {letter}
      </Typography>
    );
  }
  // Customizable Area End

  renderContactCard = (contact: Contact, index: number) => {
    const L = contact.name.charAt(0).toUpperCase();
    return (
      <Box
        data-test-id={`contact-card-${contact.id}`}
        onClick={(e) => { this.handleCardClick(contact.id); }}
        key={contact.id}
        ref={this.contactRefs[L]}
        style={{
          ...webStyle.container,
          backgroundColor: contact.backgroundColor,
          marginTop: index === 0 ? "0" : "-138px",
          position: "relative",
          zIndex: this.state.selectedCardId === contact.id ? "100" : index,
          cursor: "pointer",
          marginBottom: this.state.selectedCardId === contact.id ? "150px" : "0",
        }}
      >
        <Box style={webStyle.onlineIndicator}>
          <img src={contact.isOnline ? onlineIndicator : offlineIndicator} alt="online" width={14} height={14} />
        </Box>
        <Avatar
          src={contact.avatar}
          alt="profile"
          style={{
            ...webStyle.profileImage,
            ...(this.state.selectedCardId === contact.id
              ? {
                width: "110px",
                height: "152px",
                borderRadius: "10px",
              }
              : {}),
          }}
        />
        <Box style={webStyle.contentContainer}>
          <Box
            data-test-id="header-container"
            style={{
              ...webStyle.headerContainer,
              ...(this.state.selectedCardId === contact.id
                ? {
                  width: "212px",
                }
                : {}),
            }}
          >
            <Typography style={webStyle.name}>{contact.name}</Typography>
            <Box
              data-test-id="action-buttons"
              style={webStyle.actionButtons}>
              <IconButton style={webStyle.iconButton}>
                <img src={contact.pitch ? pitch : noPitch} alt="connect" width={22} height={22} />
              </IconButton>
              <IconButton
                data-test-id={`favorite-icon-${contact.id}`}
                style={webStyle.iconButton}
                onClick={(e) => {
                  e.stopPropagation();
                  this.handleFavoriteToggle(contact.id);
                }}>
                <img
                  src={contact.isFavorite ? favourites : notFavourites}
                  alt="share"
                  width={18}
                  height={18}
                />
              </IconButton>
            </Box>
          </Box>
          <Typography style={webStyle.role}>
            {contact.role}, {contact.company}
          </Typography>
          <Typography style={webStyle.location}>{contact.location}</Typography>
          <Box style={webStyle.connectButton}>
            {[{ src: chat, alt: "chat", width: 19.2, height: 19.2 }, { src: share, alt: "share", width: 16.8, height: 19.2 }, { src: block, alt: "block", width: 19.2, height: 19.2 }].map((img, index) => (
              <Box
                key={index}
                style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "50%",
                  backgroundColor: `rgba(${this.getDarkerColor(contact.backgroundColor, 0.3)}, 0.8)`,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  margin: "0 5px",
                  cursor: "pointer",
                  transition: "all 0.2s ease",
                }}
              >
                <img
                  src={img.src}
                  alt={img.alt}
                  width={img.width}
                  height={img.height}
                  style={{
                    transition: "transform 0.2s ease",
                  }}
                />
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
    );
  };

  renderConnectionsTab = () => {
    if (defaultContacts.length === 0) {
      return this.renderEmptyState("You Have\nNo Connections Yet\nStart Swiping!");
    }

    return (
      <Box sx={{ marginTop: "80px", flexGrow: 1, height: 'calc(100% - 60px)', position: 'relative', display: "flex", flexDirection: "row", zIndex: 1 }}>
        <div style={{ display: 'flex', flexDirection: 'column', width: '385px', height: '100%', overflowY: 'auto', position: 'relative' }}>
          {defaultContacts
            .slice()
            .sort((a, b) => a.name.localeCompare(b.name))
            .map((contact, index) => this.renderContactCard(contact, index))}
        </div>
        <Box sx={webStyle.alphabet}>
          {this.alphabetList.map((letter, index) => this.renderAlphabetItem(letter, index))}
        </Box>
      </Box>
    );
  };

  renderFavouritesTab = () => {
    const favourites = defaultContacts.filter(contact => contact.isFavorite);
    if (favourites.length === 0) {
      return this.renderEmptyState("You Have\nNo Favourites Yet\nStart Adding!");
    }

    const sortedFavourites = [...favourites].sort((a, b) => a.name.localeCompare(b.name));

    return (
      <Box sx={{ marginTop: "80px", flexGrow: 1, height: 'calc(100% - 60px)', position: 'relative', display: "flex", flexDirection: "row", zIndex: 1 }}>
        <div style={{ display: 'flex', flexDirection: 'column', width: '385px', height: '100%', overflowY: 'auto', position: 'relative' }}>
          {sortedFavourites.map((contact, index) => this.renderContactCard(contact, index))}
        </div>
        <Box sx={webStyle.alphabet}>
          {this.alphabetList.map((letter, index) => this.renderAlphabetItem(letter, index))}
        </Box>
      </Box>
    );
  };

  renderRequestsTab = () => {
    return this.renderEmptyState("You Have\nNo Requests Yet\nStart Adding!");
  };

  renderEmptyState = (message: string) => (
    <Box
      data-test-id="empty-state-box"
      sx={{ width: "273px", position: 'absolute', top: '50%', left: '53%', transform: 'translate(-50%, -50%)', color: 'white', textAlign: 'center' }}>
      <Typography variant="h6" sx={{ font: "inter", fontWeight: 500, fontSize: "25px", lineHeight: "30px", textAlign: "center", color: "#7C7C7C" }}>{message}</Typography>
    </Box>
  );

  render() {
    const activeTabContent = this.state.activeTab === "Favourites"
      ? this.renderFavouritesTab()
      : this.renderRequestsTab();

    return (
      <Box sx={{ display: 'flex', minHeight: '100vh', width: '100%', height: '100%', overflowX: 'hidden' }}>
        {/* Sidebar */}
        <Box sx={{ minHeight: '100vh', flexGrow: 0, backgroundColor: '#ffffff', borderRight: '1px solid #cbd5e1', width: '115px', height: '100%' }}>
          <NavigationMenu id={""} navigation={this.props.navigation} />
        </Box>
        {/* Main Container */}
        <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
          {/* Header */}
          <CommonHeader id={""} navigation={this.props.navigation} />
          <Box sx={{
            marginTop: "60px",
            flexGrow: 1,
            backgroundColor: '#231F1F',
            padding: '20px',
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            alignItems: "center",
          }}>
            <div style={{ flexGrow: 0, height: '58px', marginBottom: '16px', position: "fixed", top: "70px", zIndex: 2, backgroundColor: "#231F1F", padding: "8px" }}>
              <div style={tabStyle.container}>
                <Button
                  data-test-id="connections-tab"
                  sx={{
                    ...tabStyle.button,
                    ...(this.state.activeTab === "Connections" ? tabStyle.activeButton : {})
                  }}
                  onClick={() => this.handleTabClick("Connections")}
                >
                  Connections
                </Button>
                <Button
                  data-test-id="favourites-tab"
                  sx={{
                    ...tabStyle.button,
                    ...(this.state.activeTab === "Favourites" ? tabStyle.activeButton : {})
                  }}
                  onClick={() => this.handleTabClick("Favourites")}
                >
                  Favourites
                </Button>
                <Button
                  data-test-id="requests-tab"
                  sx={{
                    ...tabStyle.button,
                    ...(this.state.activeTab === "Requests" ? tabStyle.activeButton : {})
                  }}
                  onClick={() => this.handleTabClick("Requests")}
                >
                  Requests
                  <div style={tabStyle.requestCount}>
                    <span style={tabStyle.requestCountText}>5</span>
                  </div>
                </Button>
              </div>
            </div>

            {this.state.activeTab === "Connections" ? this.renderConnectionsTab() : activeTabContent}
          </Box>
        </Box>
      </Box>
    );
  }
}

// Customizable Area Start
const webStyle = {
  alphabet: {
    position: 'fixed',
    top: '60%',
    right: 'calc(50% - 312px)',
    transform: 'translateY(-50%)',
    display: 'flex',
    flexDirection: 'column' as const,
    alignItems: 'center',
    justifyContent: 'flex-start',
    width: 'fit-content',
    padding: '10px',
    backgroundColor: 'transparent',
    zIndex: 100
  },
  container: {
    width: 344,
    padding: 20,
    backgroundColor: "#ffe699",
    borderRadius: 10,
    display: "flex",
    position: "relative" as const,
    gap: 16,
    transition: "all 0.3s ease"
  },
  onlineIndicator: {
    position: "absolute" as const,
    top: 17,
    left: 18,
    zIndex: 1
  },
  profileImage: {
    width: "72px",
    height: "72px",
    borderRadius: "100px",
    objectFit: "cover" as const
  },
  contentContainer: {
    display: "flex",
    flexDirection: "column" as const,
    gap: 15
  },
  headerContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 15,
    width: "250px"
  },
  name: {
    fontFamily: "Inter",
    fontSize: 17,
    fontWeight: 800,
    lineHeight: "24px",
    color: "#000000",
  },
  actionButtons: {
    display: "flex",
    gap: 10,
  },
  iconButton: {
    padding: 0,
    transition: "transform 0.2s",
    "&:hover": {
      transform: "scale(1.1)"
    }
  },
  role: {
    fontFamily: "Inter",
    fontSize: 16,
    fontWeight: 400,
    lineHeight: "24px",
    color: "#000000"
  },
  location: {
    fontFamily: "Inter",
    fontSize: 16,
    fontWeight: 400,
    lineHeight: "24px",
    color: "#000000"
  },
  connectButton: {
    marginTop: 10,
    cursor: "pointer",
    display: 'flex',
    alignItems: 'center',
  }
};
const tabStyle = {
  container: {
    display: 'flex',
    flexDirection: 'row' as const,
    gap: '12px',
    padding: '8px',
    minWidth: '520px',
    height: '58px',
    alignItems: 'center',
    backgroundColor: 'inherit',
  },
  button: {
    borderRadius: '40px',
    border: '1px solid #c1c1c1',
    backgroundColor: '#e9e9e9',
    height: '46px',
    minWidth: '155px',
    padding: '0 20px',
    transition: 'all 0.3s ease',
    fontFamily: 'Inter, sans-serif',
    fontSize: '16px',
    lineHeight: '24px',
    color: '#303138',
    textAlign: 'center',
    textTransform: 'none'
  },
  activeButton: {
    backgroundColor: '#bbcf8d',
    height: '58px',
    minWidth: '195px',
    fontSize: '18px',
  },
  requestCount: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '28px',
    height: '28px',
    borderRadius: '50%',
    backgroundColor: '#1f1f1f',
    marginLeft: '8px',
  },
  requestCountText: {
    color: '#ffffff',
    fontSize: '12px',
    lineHeight: '24px',
  }
};
// Customizable Area End